import { render, staticRenderFns } from "./MigrationNotification.vue?vue&type=template&id=5e018e16&scoped=true"
import script from "./MigrationNotification.vue?vue&type=script&lang=js"
export * from "./MigrationNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../Users/wencesszelagowski/Downloads/gotrading/front/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e018e16",
  null
  
)

export default component.exports